<template>
  <v-select
    v-model="localValue"
    :items="filteredEvents"
    :item-value="itemValue"
    :item-text="itemText"
    :label="label"
    :multiple="multiple"
    :clearable="clearable"
    :dense="dense"
    :outlined="outlined"
    :hint="String(localValue)"
    @change="handleChange"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EventCatalogSelect",
  props: {
    value: [String, Number, Array], // v-model
    status: {
      type: String,
      default: ""
    },
    eventType: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    itemValue: {
      type: String,
      default: "eventId"
    },
    itemText: {
      type: String,
      default: "name"
    },
    label: {
      type: String,
      default: "Events"
    },
    clearable: {
      type: Boolean,
      default: true
    },
    dense: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters(["eventCatalogs"]),
    filteredEvents() {
      return this.eventCatalogs
        .filter(e => {
          const matchesStatus = this.status ? e.status === this.status : true;
          const matchesType = this.eventType ? e.eventType === this.eventType : true;
          return matchesStatus && matchesType;
        })
        .sort((a, b) => {
          // Sort by start date ascending (oldest first)
          const dateA = a.startDate ? new Date(a.startDate) : new Date(0);
          const dateB = b.startDate ? new Date(b.startDate) : new Date(0);
          return dateA - dateB;
        });
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    ...mapActions(["allEventCatalog"]),
    async fetchEvents() {
      try {
        await this.allEventCatalog();
      } catch (error) {
        console.error("Failed to fetch events:", error);
      }
    },
    handleChange(val) {
      // Find the selected event object(s)
      if (this.multiple && Array.isArray(val)) {
        const selectedEvents = this.filteredEvents.filter(e => val.includes(e[this.itemValue]));
        this.$emit('event-selected', selectedEvents);
      } else {
        const selectedEvent = this.filteredEvents.find(e => e[this.itemValue] === val);
        this.$emit('event-selected', selectedEvent);
      }
      this.$emit("input", val);
    }
  },
  created() {
    this.fetchEvents();
  }
};
</script>
